export interface Customer {
  id: string;
  name: string;
  type: ClientType;
  contactPerson?: string;
  phone?: string;
  email?: string;
  address?: string;
  additionalDetails?: string;
}

export const CLIENT_TYPES = [
  'Golf Course',
  'University',
  'Municipality',
  'School',
  'High End Residential',
  'Athletic Facility',
  'Government',
  'Commercial',
  'Other'
] as const;

export type ClientType = typeof CLIENT_TYPES[number];

export interface CustomerMap {
  id: string;
  name: string;
  lastModified: string;
  status: MapStatus;
}

export const CLIENT_STATUSES = [
  'Active',
  'Inactive',
  'Pending',
  'Archived'
] as const;

export type ClientStatus = typeof CLIENT_STATUSES[number];

export interface CustomerDetails {
  id: string;
  userId: string;
  name: string;
  type: ClientType;
  status: ClientStatus;
  totalMaps: number;
  lastModified: string;
  notes?: string;
  contactPerson: string;
  email: string;
  phone: string;
  address: string;
  maps: Array<{ id: string; name: string }>;
}

export interface Measurement {
  id: string;
  name: string;
  distance: number;
  paths: Array<{ lat: number; lng: number }>;
  color: string;
  width?: number;
}

export const MAP_STATUSES = [
  'Active',
  'Archived',
  'Draft',
  'Pending'
] as const;

export interface Zone {
  id: string;
  name: string;
  paths: Array<{ lat: number; lng: number }>;
  color: string;
  area?: number;
}

export interface Marker {
  id: string;
  position: { lat: number; lng: number };
  label?: string;
  icon?: string;
  type?: string;
}

export interface MapDetails {
  id: string;
  name: string;
  center: { lat: number; lng: number };
  zoom: number;
  zones: Zone[];
  markers: Marker[];
  measurements: Measurement[];
  customerId: string;
  lastModified: string;
}

export type MapStatus = typeof MAP_STATUSES[number];

// Add color mappings for each client type
export const CLIENT_TYPE_COLORS = {
  'Golf Course': 'emerald',
  'University': 'blue',
  'Municipality': 'purple',
  'School': 'yellow',
  'High End Residential': 'pink',
  'Athletic Facility': 'orange',
  'Government': 'red',
  'Commercial': 'indigo',
  'Other': 'slate'
} as const;

export type ClientTypeColor = keyof typeof CLIENT_TYPE_COLORS; 